const WindowsIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1143 9.5901L3.16699 9.5901L3.16699 2.6665L10.1143 2.6665L10.1143 9.5901Z"
        fill="white"
      />
      <path
        d="M17.7848 9.5901L10.8377 9.5901L10.8377 2.6665L17.7848 2.6665L17.7848 9.5901Z"
        fill="white"
      />
      <path
        d="M10.114 17.2372L3.16699 17.2372L3.16699 10.3137L10.114 10.3137L10.114 17.2372Z"
        fill="white"
      />
      <path
        d="M17.7848 17.2372L10.8377 17.2372L10.8377 10.3137L17.7848 10.3137L17.7848 17.2372Z"
        fill="white"
      />
    </svg>
  );
};

export default WindowsIcon;
